'use server'

import { Specialty } from '../common/interfaces/specialty.interface'
import { apiRequest, ApiResponse } from '../request'

export async function getSpecialties(
    organizationId?: number
): Promise<ApiResponse<Specialty[]>> {
    return apiRequest<Specialty[]>('specialties', {
        params: organizationId ? { organizationId } : {},
    })
}

export async function getSpecialty(
    id: number
): Promise<ApiResponse<Specialty>> {
    return apiRequest<Specialty>(`specialties/${id}`, {})
}

export async function getSpecialtiesByOrganization(
    organizationId: number
): Promise<ApiResponse<Specialty[]>> {
    return apiRequest<Specialty[]>(`specialties/organization/${organizationId}`, {})
}

export async function getAllWithSubspecialtiesByOrganization(
    organizationId: number
): Promise<ApiResponse<Specialty[]>> {
    return apiRequest<Specialty[]>(`specialties/organization/${organizationId}/all`, {})
}

export async function getSpecialtiesOnlyByOrganization(
    organizationId: number
): Promise<ApiResponse<Specialty[]>> {
    return apiRequest<Specialty[]>(`specialties/organization/${organizationId}/specialties`, {})
}

export async function getSubspecialtiesByOrganization(
    organizationId: number
): Promise<ApiResponse<Specialty[]>> {
    return apiRequest<Specialty[]>(`specialties/organization/${organizationId}/subspecialties`, {})
}

export async function getSubspecialtiesByParent(
    parentId: number
): Promise<ApiResponse<Specialty[]>> {
    return apiRequest<Specialty[]>(`specialties/${parentId}/subspecialties`, {})
}

export async function createSpecialty(data: {
    name: string
    organizationId?: number
    parentId?: number | null
}): Promise<ApiResponse<Specialty>> {
    return apiRequest<Specialty>('specialties', { data }, 'post')
}

export async function updateSpecialty(
    id: number,
    data: {
        name?: string
        parentId?: number | null
    }
): Promise<ApiResponse<Specialty>> {
    return apiRequest<Specialty>(`specialties/${id}`, { data }, 'patch')
}

export async function deleteSpecialty(
    id: number
): Promise<ApiResponse<void>> {
    return apiRequest<void>(`specialties/${id}`, {}, 'delete')
}
